import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateSiteStartPageParams {
  startPage: string;
  siteId?: string;
}

export interface IUpdateStringServerSettingResult {
}

export class UpdateSiteStartPageRequest extends Request<IUpdateSiteStartPageParams, IUpdateStringServerSettingResult> {
  constructor(params: IUpdateSiteStartPageParams) {
    super('updateSiteStartPage', params);
  }
}
